export function fmtL(n) {
  if (n == null || !isFinite(n)) return '-';
  return (n / 100000).toFixed(2) + 'L';
}

export function fmtNum(n, d = 2) {
  if (n == null || !isFinite(n)) return '-';
  return Number(n).toLocaleString('en-IN', { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function fmtDateLabel(iso) {
  if (!iso) return '—';
  const d = new Date(iso + 'T12:00:00');
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-');
}